import React from 'react';

const ImagePlaceholderIcon = (props: any) => (
  <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="0.900146" width="16" height="16" rx="2.28571" fill="#ABABAB" />
    <g filter="url(#filter0_d_724_22564)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.22485 6.54293C8.66668 6.54293 9.02485 6.18476 9.02485 5.74293C9.02485 5.3011 8.66668 4.94293 8.22485 4.94293C7.78302 4.94293 7.42485 5.3011 7.42485 5.74293C7.42485 6.18476 7.78302 6.54293 8.22485 6.54293ZM4.23096 10.1061L6.07736 7.27318C6.38401 6.80269 7.0673 6.78633 7.39612 7.24161L7.59054 7.51081C7.91836 7.96472 8.59906 7.95011 8.90712 7.48257L9.89835 5.97812C10.2181 5.49285 10.9322 5.49963 11.2427 5.9909L13.8492 10.1156C14.1858 10.6482 13.8031 11.3429 13.1729 11.3429H4.90117C4.26598 11.3429 3.88413 10.6383 4.23096 10.1061Z"
        fill="url(#paint0_linear_724_22564)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_724_22564"
        x="0.671282"
        y="3.22865"
        width="16.7314"
        height="13.2572"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.71429" />
        <feGaussianBlur stdDeviation="1.71429" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.479167 0 0 0 0 0.479167 0 0 0 0 0.479167 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_724_22564" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_724_22564" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_724_22564"
        x1="8.89985"
        y1="8.14293"
        x2="13.6999"
        y2="10.9429"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#FAFAFA" />
      </linearGradient>
    </defs>
  </svg>
);

export default ImagePlaceholderIcon;
